import { Suggestion, SuggestionKind } from 'owa-search-service';

/**
 * Merge suggestions so that they appear in the correct order in the suggestions
 * context menu.
 *
 * 3S suggestion (keywords + people)
 * category suggestion
 * -----------------------------
 * message suggestion
 * file suggestion
 */
export default function orderSuggestions(suggestions: Suggestion[]): Suggestion[] {
    // Get 3S suggestions.
    const substrateSuggestions = suggestions.filter(
        (suggestion: Suggestion) =>
            suggestion.kind === SuggestionKind.Keywords || suggestion.kind === SuggestionKind.People
    );

    // Get category suggestions.
    const categorySuggestions = suggestions.filter(
        (suggestion: Suggestion) => suggestion.kind === SuggestionKind.Category
    );

    // Get message suggestions.
    const messageSuggestions = suggestions.filter(
        (suggestion: Suggestion) => suggestion.kind === SuggestionKind.Message
    );

    // Get file suggestions.
    const fileSuggestions = suggestions.filter(
        (suggestion: Suggestion) => suggestion.kind === SuggestionKind.Files
    );

    // Merge suggestions.
    return [].concat(
        substrateSuggestions,
        categorySuggestions,
        messageSuggestions,
        fileSuggestions
    );
}
